import React from 'react';
import { Box, Container } from '@mui/material';
import { COLOR_PURPLE } from 'styles/variables/colors';
import HeaderInformationMobile from '../HeaderInformationMobile';
import InstitutionsCommunicationMobile from 'components/InstitutionsCommunicationMobile';
import CustomLandingPageMobile from 'components/CustomLandingPageMobile';
import TrustedOneHundredInstitutionsMobile from 'components/TrustedOneHundredInstitutionsMobile';
import BookDemoMobile from 'components/BookDemoMobile';
import BenefitedDepartmentsMobile from 'components/BenefitedDepartmentsMobile';
import PublishedSectionMobile from 'components/PublishedSectionMobile';
import ReferToAcademicInstitutionMobile from 'components/ReferToAcademicInstitutionMobile';
import CreatingScienceIllustrationsMobile from 'components/CreatingScienceIllustrationsMobile';

export default function AcademicContentMobile() {
  return (
    <>
      <Box py={1} bgcolor={COLOR_PURPLE} height={230}>
        <Container>
          <HeaderInformationMobile
            marginLeftPercentage={15}
            textTitle="For Academic Institutions"
            textDescription="Get in touch with our team to offer the best science infographic maker for your associates."
          />
        </Container>
      </Box>

      <InstitutionsCommunicationMobile
        textTitle={
          <>
            The best science infographic maker <br /> for scholarly communication
          </>
        }
        textInformation="Academic users can easily create beautiful graphical abstracts, presentations,
        infographics and more. Browse through 75,000+ scientifically-accurate illustrations in
        more than 80 study fields."
        textButton="Inspire Science Outcomes"
      />

      <CustomLandingPageMobile
        textTitle={
          <>
            Custom landing page with <br /> email authentication
          </>
        }
        textDescription={
          <>
            Use the institution's visual identity to
            <b>strengthen the brand experience</b> while protecting user data. Through domain- based
            authentication and an assigned account manager,{' '}
            <b>all users can log in using their academic email.</b>
          </>
        }
        textButton="Get a Custom Experience"
      />

      <TrustedOneHundredInstitutionsMobile textTitle="Mind the Graph's trusted by 100+ academics institutions worldwide" />

      <BookDemoMobile />

      <Box bgcolor="#FFFFFF" py={4}>
        <CreatingScienceIllustrationsMobile textTitle="A perfect tool for students creating science illustrations" />
      </Box>

      <BenefitedDepartmentsMobile />

      <PublishedSectionMobile titlePublished="Mind the Graph has been cited in many journals worldwide" />

      <ReferToAcademicInstitutionMobile
        textTitle={
          <>
            Refer Mind the Graph to <br /> your Academic Institution
          </>
        }
        textSubtitle={
          <>
            If your University or College is not <br /> yet communicating science properly, <br />{' '}
            refer Mind the Graph to them.
          </>
        }
        textInformation={
          <>
            Insert the person in charge email <br /> address below and we'll get in touch.
          </>
        }
      />
    </>
  );
}
